module.exports = __webpack_public_path__ + "static/media/Map_3.83508475.png";